module.exports = __webpack_public_path__ + "static/media/eocr.c4de479e.svg";